import React from "react";

const Tag = ({ text }) => (
  <span style={{ paddingLeft: 5 }}>
    <span className="badge badge-secondary">{text}</span>
  </span>
);

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Tag/index.jsx